import { Component, inject, Input, OnInit } from '@angular/core';
import { CustomCard } from '../custom-card.types';
import { DocumentOwnerData } from '@workflow/ecp-shared/model/documentMetaData.model';
import { StatefulValue } from '@workflow/class/stateful-value.class';
import { CardElementsBaseComponent } from '@workflow/dynamic-render/card/shared/card-elements-base.component';
import { WorkflowService } from '@workflow/service/workflow/workflow.service';
import { StatefulService } from '@app/service/stateful.service';
import { CardInstance } from '@workflow/class/card.service';
import { FieldInstance } from '@workflow/class/field.service';
// eslint-disable-next-line max-len

// TODO: why do we need this? why not use ngClass? Are we storing layout styles in the DB?
const OAO_PRIMARY_APPLICANT_ROOT = 'api:oaoMemberInformation/primaryApplicant';
const OAO_CO_APPLICANT_ROOT = 'api:oaoMemberInformation/coApplicant';
const OAO_ADDITIONAL_CO_APPLICANT_ROOT = 'api:oaoMemberInformation/additionalCoApplicant';
const OAO_RESPONSIBLE_PARTIES_ROOT = 'api:oaoMemberInformation/businessInformation/responsibleParties';
const OAO_RESPONSIBLE_PARTIES_COUNT = 'api:oaoMemberInformation/businessInformation/responsiblePartyCount';
const OAO_MEMBERSHIP_TYPE = 'api:oaoMemberInformation/membership/membershipTypeName';

@CustomCard('cu-document-card-fields')
@Component({
  selector: 'cu-dynamic-document-card-fields',
  templateUrl: './card-fields-requested-document.html'
})
export class CardFieldsReqestedDocumentComponent extends CardElementsBaseComponent implements OnInit {
  @Input() public cardId;

  public primaryDocFields: FieldInstance[];
  public coApplicantDocFields: FieldInstance[];
  public additionalCoApplicantDocFields: FieldInstance[];
  public applicantList: DocumentOwnerData[] = [];
  private readonly statefulService = inject(StatefulService);

  constructor(private readonly workflowService: WorkflowService) {
    super();
  }
  public ngOnInit(): void {
    // applies to indicate 0 - all, 1 - primary, 2 - coApplicant, ''/undefined - when empty
    this.primaryDocFields = this.card.fields.filter(
      (t) =>
        t.visible &&
        (t.config.appliesTo === '1' || t.config.appliesTo === '0' || t.config.appliesTo === undefined || t.config.appliesTo === '')
    );
    this.coApplicantDocFields = this.card.fields.filter((t) => t.visible && (t.config.appliesTo === '2' || t.config.appliesTo === '0'));
    this.additionalCoApplicantDocFields = this.card.fields.filter((t) => t.visible && t.config.appliesTo === '0');
    if (!this.isBusinessMembership()) {
      this.addToApplicantList(OAO_PRIMARY_APPLICANT_ROOT, 0);
      this.addToApplicantList(OAO_CO_APPLICANT_ROOT, 1);
      this.addToApplicantList(OAO_ADDITIONAL_CO_APPLICANT_ROOT, 2);
    } else {
      const responsiblePartyCount = this.statefulService.wrap(OAO_RESPONSIBLE_PARTIES_COUNT).valueStringOnly;
      if (Number.parseInt(responsiblePartyCount) > 0) {
        const responsibleParties = StatefulValue.arraySize(OAO_RESPONSIBLE_PARTIES_ROOT);
        for (let i = 0; i < responsibleParties; i++) {
          // eslint-disable-next-line @typescript-eslint/no-shadow
          this.addToApplicantList(`${OAO_RESPONSIBLE_PARTIES_ROOT}/${i}`, i);
        }
      }
    }

    // Hide coborrower requested documents
    if (this.coApplicantDocFields?.length > 0 && this.applicantList.length > 0 && this.applicantList.length < 2) {
      this.coApplicantDocFields
        .filter((t) => t.config.appliesTo === '2')
        .forEach((field: FieldInstance) => {
          field.config.visible = false;
        });
    }
  }

  /**
   * Add applicant to the list
   * @param firstName
   * @param lastName
   */
  public addToApplicantList = (apiPrimaryRoot: string, value: number) => {
    const applicants: DocumentOwnerData = {
      firstName: this.statefulService.wrap(`${apiPrimaryRoot}/firstName`).valueStringOnly,
      lastName: this.statefulService.wrap(`${apiPrimaryRoot}/lastName`).valueStringOnly,
      uploadedBy: value
    };
    if (applicants.firstName) {
      this.applicantList.push(applicants);
    }
  };

  public isBusinessMembership = (): boolean => {
    const value = this.statefulService.wrap(OAO_MEMBERSHIP_TYPE).valueString;
    return value && value.toLowerCase() === 'business';
  };

  /**
   * Returns selected card visiblity value
   */
  public visibleCards(): CardInstance[] {
    return this.workflowService.currentPage.cards.filter((card) => card.visible);
  }

  // TEMP: this needs to be handled by the workflow to validate all nested fields recursively
  public allFieldsInCardValid(fields): boolean {
    const visibleFields = fields.filter((field) => {
      return field.visible || field.nestedFields.find((nested) => nested.visible);
    });
    const invalidFields = visibleFields.filter((field) => {
      return field.visible && (!field.valid || field.nestedFields.find((nested) => !nested.valid && nested.visible));
    });
    return invalidFields.length === 0;
  }
}
